import mitt, { type Emitter } from 'mitt';

import type { DiscoverMWPayEvents } from './DiscoverMWPay.types';

// We use emitter to communicate between components, so we don't need to pass props down the tree,
// It's a way to optimize performance and avoid unnecessary re-renders.
// In current shape it's used to show/hide sticky footer, which we could perhaps do with CSS only,
// but that requires greater refactor and it's not a big deal in this case.
// besides, event driven architecture is the new Motorway way of doing things :)
export const DiscoverMWPayEmitter: Emitter<DiscoverMWPayEvents> = mitt();
